import { useCallback, useRef } from "react";
import { baseURL, useFetch } from "../../custom/api";
import { toFarsiNumber } from "../../custom/helpers";
import { formatJalali } from "../challenges/jalaliDate";

// Thin wrapper over the app's myFetch that parses JSON and throws an Error
// carrying the server's Persian message + machine-readable code.
export function useGroupApi() {
  const { myFetch } = useFetch();
  const ref = useRef(myFetch);
  ref.current = myFetch;

  // stable identity so it can safely live in effect dependency lists
  const call = useCallback(async (url, options = {}) => {
    const resp = await ref.current(url, options);
    let data = null;
    try {
      data = await resp.json();
    } catch (e) {
      data = null;
    }
    if (!resp.ok) {
      const d = data && data.detail;
      const err = new Error((d && d.message) || "مشکلی پیش اومد، دوباره امتحان کن");
      err.status = resp.status;
      err.code = d && d.code;
      err.detail = d;
      throw err;
    }
    return data;
  }, []);

  const json = useCallback(
    (url, method, body) =>
      call(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: body === undefined ? undefined : JSON.stringify(body),
      }),
    [call]
  );

  return { call, json };
}

export const imageUrl = (path) => (path ? `${baseURL}/${path}` : null);

export const inviteLink = (token) => `${window.location.origin}/group/invite/${token}`;

export const PENDING_INVITE_KEY = "pendingGroupInvite";

export function toIsoDay(dateObject) {
  const g = dateObject.convert(); // gregorian
  const pad = (n) => String(n).padStart(2, "0");
  return `${g.year}-${pad(g.month.number)}-${pad(g.day)}`;
}

export function formatTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("fa-IR", { hour: "2-digit", minute: "2-digit" });
}

export function formatDayHeading(iso) {
  return toFarsiNumber(formatJalali(iso, "dddd DD MMMM"));
}

export function relativeTime(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "همین الان";
  if (diff < 3600) return `${toFarsiNumber(Math.floor(diff / 60))} دقیقه پیش`;
  if (diff < 86400) return `${toFarsiNumber(Math.floor(diff / 3600))} ساعت پیش`;
  if (diff < 86400 * 7) return `${toFarsiNumber(Math.floor(diff / 86400))} روز پیش`;
  return toFarsiNumber(formatJalali(iso, "DD MMMM"));
}

export const MEAL_LABELS = {
  breakfast: "صبحانه",
  snack1: "میان‌وعده صبح",
  lunch: "نهار",
  snack2: "میان‌وعده عصر",
  dinner: "شام",
  snack3: "میان‌وعده شب",
};
export const MAIN_MEALS = ["breakfast", "lunch", "dinner"];
export const SNACKS = ["snack1", "snack2", "snack3"];
